export const USER_PERMISSIONS = {
  // Candidate portal
  GUEST: 'guest',
  CANDIDATE: 'candidate',

  // HR portal
  HR_PORTAL: 'hr_portal',
  HR: 'hr',
  COLLABORATION: 'collaboration',
  EDIT_COMPANY: 'edit_company',
  POST_COMPANY: 'post_company',
  GROUP_COMPANY: 'group_company',

  // Internal admin (H-* roles)
  SUPERADMIN: 'superadmin',
  H_LOGIN: 'h_login',
  H_MARKETING: 'h_marketing',
  H_MARKETINGADMIN: 'h_marketingadmin',
  H_DEV: 'h_dev',
  H_USERS: 'h_users',
  H_COMPANIES: 'h_companies',
};

export const USER_ROLES = {
  COMPANY_ADMIN:    'company_admin',
  HR:               'hr',
  COLLABORATOR:     'collaborator',
  GROUP_ADMIN:      'group_admin',
  H_MARKETING:      'H-marketing',
  H_MARKETINGADMIN: 'H-marketinadmin',
  H_DEV:            'H-dev',
  H_USERADMIN:      'H-useradmin',
  HIDDEN_ADMIN:     'hidden_admin',
  SUPERADMIN:       'superadmin',
};

export const APPLICATION_STAGES = {
  SOURCED: '10_sourced',
  APPLIED: '20_applied',
  PHONE_SCREEN: '30_phone_screen',
  ASSESSMENT: '40_assessment',
  OFFER: '60_offer',
  HIRED: '70_hired',
  REJECTED: '90_rejected',
};

export const APPLICATION_STAGE_LABELS = {
  [APPLICATION_STAGES.SOURCED]: 'Sourced',
  [APPLICATION_STAGES.APPLIED]: 'Applied',
  [APPLICATION_STAGES.PHONE_SCREEN]: 'Phone Screen',
  [APPLICATION_STAGES.ASSESSMENT]: 'Assessment',
  [APPLICATION_STAGES.OFFER]: 'Offer',
  [APPLICATION_STAGES.HIRED]: 'Hired',
  [APPLICATION_STAGES.REJECTED]: 'Rejected',
};
